import { DefaultImageProps } from './types';
import { PLAY_MARKET_IMAGE_URL } from './urls';

export const PlayMarketImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={PLAY_MARKET_IMAGE_URL}
    alt="play-market"
    {...props}
  />
);
